import ServicesTopFAQ from "./ServicesTopFAQ";

export default ServicesTopFAQ;
